import { ThemeProvider } from "@material-ui/core/styles";
import { CastersProvider } from "./CastersContext";
import { CastersPage } from "./CastersPage";
import dataEntries from "./styles/useDataEntryStyles";

type Props = {};
const CasterDataEntryV2 = (props: Props) => {
	return (
		<CastersProvider>
			<ThemeProvider theme={dataEntries}>
				<CastersPage />
			</ThemeProvider>
		</CastersProvider>
	);
};
export default CasterDataEntryV2;
